import * as React from 'react';

function SvgTrash(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="13"
      viewBox="0 0 12 13"
      fill="black"
      {...props}
    >
      <path d="M8.375 2.25V1.125H8.5C8.4314 1.125 8.37524 1.06855 8.375 1V1.125H3.625V1C3.62476 1.06847 3.56849 1.12487 3.5 1.125H3.625V2.25H8.375ZM2.19531 3.375L2.57324 11.375H9.42676L9.80469 3.375H2.19531ZM11.5 2.25C11.7765 2.25013 12 2.47352 12 2.75V3.25C11.9998 3.31847 11.9435 3.37487 11.875 3.375H10.9307L10.5449 11.5469C10.5197 12.081 10.081 12.4999 9.54688 12.5H2.45312C1.92046 12.5 1.47932 12.0795 1.4541 11.5469L1.06836 3.375H0.125C0.0563994 3.375 0.000243737 3.31855 0 3.25V2.75C0 2.47344 0.223437 2.25 0.5 2.25H2.5V1C2.5 0.448437 2.94844 0 3.5 0H8.5C9.05145 0.000127582 9.5 0.448516 9.5 1V2.25H11.5Z" />
    </svg>
  );
}

export default SvgTrash;
